RivalIQ.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const PrivateMetadataSummary = RivalIQ.data.CacheLayer.extend({
        name: 'Private Metadata Summary',
        cacheKeys: [],

        loadData: function (attrs) {
            const url = ['/api/landscapes/', attrs.landscapeId, '/privateMetadataSummary'].join('');
            return $.get(url).then(function (data) {
                return data;
            });
        }
    });

    data.privateMetadataSummary = new PrivateMetadataSummary();
});
